
namespace GeniuzPOS.Purchase {
    import fld = ListAppPurOrderRow.Fields

    @Serenity.Decorators.registerClass()
    export class ListAppPurOrderGrid extends Serenity.EntityGrid<ListAppPurOrderRow, any> {
        protected getColumnsKey() { return ListAppPurOrderColumns.columnsKey; }
        protected getDialogType() { return ListAppPurOrderDialog; }
        protected getIdProperty() { return ListAppPurOrderRow.idProperty; }
        protected getInsertPermission() { return ListAppPurOrderRow.insertPermission; }
        protected getLocalTextPrefix() { return ListAppPurOrderRow.localTextPrefix; }
        protected getService() { return ListAppPurOrderService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            // let self = this;
            // self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            let filters = super.getQuickFilters();


             

            var userId = Q.first(Administration.UserRow.getLookup().items, x => x.Username == Authorization.userDefinition.Username);
            var userapprole = Q.tryFirst(Administration.UserApprovalRoleRow.getLookup().items, x => x.UserId == userId.UserId);
            if(userapprole != null){

            Q.first(filters, x => x.field == fld.WaitApprove).init = w => {

                (w as Serenity.StringEditor).value = userapprole.ApprGroupCode ?? "";
               
            };
            }

            return filters;
        }
    }
}